<script lang="ts" setup>
import type { MenuItem } from '@/objects/MenuItem';
import { UserComp, ButtonComp, MenuNormal } from '@/components';

const props = defineProps({
    menu: Array<MenuItem>,
});
</script>
<template>
    <ButtonComp
        button-type="Secondary"
        data-bs-toggle="offcanvas"
        data-bs-target="#offcanvasRight"
        aria-controls="offcanvasRight"
        icon="fa-bars"
        class="btn-sm"
    />
    <div
        class="offcanvas offcanvas-end mainmenu"
        tabindex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasRightLabel"
    >
        <div class="offcanvas-header">
            <div class="d-flex align-items-center gap-3 justify-content-between flex-row-reverse">
                <UserComp :disablemenu="true" />
            </div>
            <ButtonComp
                button-type="Secondary"
                data-bs-dismiss="offcanvas"
                class="btn-sm ms-auto"
                aria-label="Close"
                icon="fa-xmark"
            />
        </div>
        <div class="offcanvas-body d-flex flex-column">
            <MenuNormal :menu="menu" />
        </div>
    </div>
</template>
